<template>
    <section>
        <div v-show="showlist">
        <sy-baselist
                ref="list"
                :filters="filters"
                editVue="business/Project_Edit.vue"
                listUrl="server/business/Project.ashx?cmd=GetList"
                deleteUrl="server/business/Project.ashx?cmd=Delete"
                :pageSize="20"
                hideAdd
                DelTips="该项目相关的所有阶段和动态将会被同时删除，确定删除吗？"
        >
            <el-table-column prop="FName" label="项目名称" width="150">
                 <template scope="scope">
                        <a href="javascript:;" @click="showdutys(scope.row)">{{ scope.row.FName }}</a>
                    </template>
            </el-table-column>
              <el-table-column prop="MouldName" label="项目模板" width="150">
            </el-table-column>
              <el-table-column prop="DutyTypeName" label="型号" width="150" v-if="false">
            </el-table-column>
            <el-table-column prop="FStartTime" label="启动时间" :formatter="formatDate2" width="180" sortable>
            </el-table-column>
              <el-table-column prop="FEndTime" label="结束时间" :formatter="formatDate2" width="180" sortable>
            </el-table-column>
            <el-table-column prop="AssignUserName" label="指派人" width="150" sortable>
            </el-table-column>
             <el-table-column prop="FProgress" label="进度(%)" width="150" sortable>
            </el-table-column>
             <el-table-column prop="FStatus" label="状态" :formatter="formatStatus" width="120">
            </el-table-column>
          
            <template scope="props" slot="extendbtn">
                 <el-button size="mini" class="el-icon-view el-button el-button--text el-button--mini"  @click="showdutys(props.row)">项目详情</el-button>
                  <!-- <el-button size="mini" v-if="props.row.FStatus==0" class="el-icon-view el-button el-button--text el-button--mini"  @click="startproject(props.row)">启动</el-button>
                  <el-button size="mini" v-if="props.row.FStatus==1||props.row.FStatus==2" class="el-icon-view el-button el-button--text el-button--mini"  @click="finishproject(props.row)">结束</el-button> -->
            </template>
        </sy-baselist>
        </div>
    
          <div v-show="showduty">
            <a @click="showlists" style="color:#409EFF;margin-left: 20px;cursor:pointer;">&lt; 返回</a>
                  
            <projectDetail  ref="projectdetail"></projectDetail>
        </div>
    </section>
</template>

<script>
     import util from '../../common/util'
    import mixin from '../../common/mixin'
    import projectDetail from "../business/ProjectDetail.vue"
    export default {
         components:{
            projectDetail
        },
        mixins: [mixin],
        data(){
            return {
            
                filters: [
                    {type: "string",name:"FName",text:"项目名称", value: null},
                     {type: "select",name:"FAssignUserId",text:"指派人",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"},
                          {type: "date",name:"FStartTime",text:"启动时间", value: null},
                    {type:"select",name:"FStatus",text:"状态",data:[[0,"未开始"], [1,"进行中"],[3,"已完成"]]}

                ],
                showduty:false,
                showlist:true,
                joblist:[]
            }
        },
        methods:{
            showdutys(row){
                this.showlist=false
                this.showduty=true
                this.$refs.projectdetail._initDetail(row)
            },
            formatStatus(row){
                let status=""
                switch(row.FStatus){
                    case 0: {status='未开始'; break;}
                    case 1: {status='进行中'; break;}
                    case 2: {status='暂停中'; break;}
                    case 3: {status='已结束'; break;}
                }
                return status
            },
            showlists(){
                 this.showlist=true
                 this.showduty=false
            },
            startproject(row){
                  let url = "server/business/Project.ashx?cmd=StartProject"
                  util.get(url,{FID:row.FID},this.progressFn,result=>{
                    util.msgSuc("项目启动成功")
                    this.$refs.list._refrash()
                })
            },
            finishproject(row){
                let url = "server/business/Project.ashx?cmd=FinishProject"
                util.get(url,{FID:row.FID},this.progressFn,result=>{
                    util.msgSuc("项目结束成功")
                    this.$refs.list._refrash()
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Project.vue